<template>
    <CRow>
        <CCol>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid'
                          :dataSource='data'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='query'
                          :recordDoubleClick="recordDoubleClick"
                          :commandClick="duplicateContracts"
                          :actionBegin ='actionBegin'
                          :actionComplete ='actionComplete'
                          :actionFailure ='actionFailure'
                          :enablePersistence ="true"
                          :dataBound='onGridDataBound' width="100%" height="100%">
                    <e-columns>
                        <e-column field='contractId' headerText='Id' :isPrimaryKey='true' width=120 :visible='true' type="number"></e-column>
                        <e-column field='contractName' headerText='Contract Name' :template='cTemplate' width=300 type="string"></e-column>
                        <e-column field='supplierName' headerText='Supplier Name' width=170 type="string"></e-column>
                        <e-column field='clientName' headerText='Client Name' width=270 type="string"></e-column>
                        <e-column field='companyName' headerText='Company Name' width=270 type="string"></e-column>
                        <e-column field='stateName' headerText='Country' width=170 type="string"></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' width=170 type="string"></e-column>
                        <e-column field='contractTypeName' headerText='Contract Type' width=170 type="string"></e-column>
                        <e-column field='startDate' headerText='Start Date' width=150 :format="dateFormatOptions"></e-column>
                        <e-column field='endDate' headerText='End Date' width=150 :format="dateFormatOptions"></e-column>
                        <e-column field='duration' headerText='Duration' width=150 type="number"></e-column>
                        <e-column field='riskManagerName' headerText='Risk Manager' width=170 type="string"></e-column>
                        <e-column field='defaultMechanism' headerText='Default Mechanism' width=170 type="string"></e-column>
                        <e-column field="Commands" headerText="Actions" width=150 :commands="commands"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import {
        GridPlugin,
        Edit,
        Page,
        Toolbar,
        Sort,
        Filter,
        Reorder,
        Resize,
        ExcelExport,
        ForeignKey,
        CommandColumn
    } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import ColumnTemplate from '@/views/helperTemplates/ColumnTemplate.vue';
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DropDownListPlugin);
    let DialogConfirmDeleteContract = undefined;

    export default {
        name: 'Contracts',
        data() {
            return {

                data: SyncHelper.getDataManager("contract"),
                cTemplate: function () {
                 
                    return {
                        template: {
                            extends: ColumnTemplate

                        }
                    }
                },
                initial: true,
                pageSettings: gridOptions.pageSettings,
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddContract' },
                { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditContract' },
                { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteContract' }, 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                commands: [
                    {
                  
                        buttonOption: { content: "Duplicate", cssClass: "e-primary custombutton" }
                    }  // bind the button here
                ],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddContract') {
                    this.$router.push({ name: "Contract" });
                }
                if (args.item.id === 'EditContract') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        this.$router.push({ name: "Contract", params: { contractId: selectedClient[0].contractId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Contract first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id === 'DeleteContract') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        DialogConfirmDeleteContract = DialogUtility.confirm({
                            title: 'Confirm Delete',
                            content: "Are you sure you want to delete contract?",
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.confirmDeleteContract },
                            cancelButton: { text: 'Cancel', click: this.cancelDeleteContract },
                            open: () => {
                                this.$refs.focusElement.focus();
                            },
                            showCloseIcon: true,
                            closeOnEscape: true,
                        });                   
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Contract first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Contract.xlsx", this.$refs);
                }
            },

            confirmDeleteContract: function () {
                this.$refs.grid.showSpinner();
                let selectedClient = this.$refs.grid.getSelectedRecords();
                apis.protectedApi.delete(`contract/${selectedClient[0].contractId}`)
                    .then(response => {
                        if (!response.data.isValid) {
                            DialogUtility.alert({
                                title: 'Alert Dialog',
                                content: response.data.errorMessage,
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' },
                                zIndex: 1100
                            });
                            this.$refs.grid.hideSpinner();
                            return;
                        }
                        let message = {
                            title: 'Success!',
                            content: 'Contract is deleted successfully',
                            cssClass: 'e-toast-success'
                        };

                        this.$root.$emit('showToast', message);
                        this.$refs.grid.hideSpinner();
                        this.$refs.grid.refresh();
                    }).catch(e => {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    });

                DialogConfirmDeleteContract.hide();

            },

            cancelDeleteContract: function () {
                DialogConfirmDeleteContract.hide();
            },

            recordDoubleClick: function (e) {
                if (!this.$store.state.permissions["Permissions.Contract.Update"] && !this.$store.state.permissions["Permissions.Contract.View"] ) return;
                this.$router.push({ name: "Contract", params: { contractId: e.rowData.contractId } });
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            duplicateContracts: function (args) {
                // event will be triggered when we click the command column button
                if (this.$store.state.permissions["Permissions.Contract.Create"]) {    //add message for duplicate contract only create permission
                    if (args.target.classList.contains("custombutton")) {
                        this.$refs.grid.showSpinner();
                        apis.protectedApi.post(`contract/duplicate?contractId=${args.rowData.contractId}`)
                            .then(response => {
                                let message = {
                                    title: 'Success!',
                                    content: 'Contract is duplicated successfully',
                                    cssClass: 'e-toast-success'
                                };
                                this.$root.$emit('showToast', message);
                                this.$refs.grid.hideSpinner();
                                this.$refs.grid.refresh();
                            }).catch(e => {
                                this.$refs.grid.hideSpinner();
                                if (e.response) {
                                    this.showErrorDialog(e.response.data.message);
                                }
                            });
                    }
                } else {
                    let message = {
                        title: 'Warning!',
                        content: 'You do not have perrmisson for this action.',
                        cssClass: 'e-toast-warning'
                    };
                    this.$root.$emit('showToast', message);
                }

            },
            onGridDataBound: function (args) {
                if (!this.$route.params.utilityType) {
                    this.initial = false;
                    return;
                } 
                if (this.initial) {
                    if (this.$route.params.utilityType == "power") {
                        this.$refs.grid.filterByColumn('utilityTypeName', 'equal', "Electricity");
                        this.initial = false;
                    } else if (this.$route.params.utilityType == "gas") {
                        this.$refs.grid.filterByColumn('utilityTypeName', 'equal', "Gas");
                        this.initial = false;
                    }
                }
            },
            setToolbarVisibility: function () {
                if (!this.$store.state.permissions["Permissions.Contract.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddContract'], false);
                }
                if (!this.$store.state.permissions["Permissions.Contract.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteContract'], false);
                }
                if (!this.$store.state.permissions["Permissions.Contract.Update"] && !this.$store.state.permissions["Permissions.Contract.View"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditContract'], false);
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
        },
        computed: {
            query: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        },
        mounted() {
            this.setToolbarVisibility();
        }
    }
</script>

<style scoped>
</style>